import { css } from 'lit';

export const style = css`
  .smsOptInError,
  /* stylelint-disable-next-line selector-id-pattern */
  #smsOptInAlert {
    margin-top: 1rem;
  }
`;
